import { Component, OnInit, Inject } from '@angular/core';
import { DatePipe, Location } from "@angular/common";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from "@angular/router";
import { animate, style, transition, trigger } from '@angular/animations';
import * as Feather from 'feather-icons';
import { CommonmastersService } from "../../commonmasters/commonmasters.service";
import { FinancialyearpopupComponent } from "../../loan/shared/popup/financialyearpopup/financialyearpopup.component";
import { AuthService } from "../../login/shared/auth.service";
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';
import { AutologoutService } from "../../login/shared/autologout.service";
import { Role } from "./../../helpers/role"

@Component({
  selector: 'app-masterlayout',
  templateUrl: './masterlayout.component.html',
  styleUrls: ['./masterlayout.component.css'],
  animations: [
    trigger('slidein', [
      transition(':enter', [
        // when ngif has true
        style({ transform: 'translateX(-100%)' }),
        animate(250, style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        // when ngIf has false
        animate(250, style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})
export class MasterlayoutComponent implements OnInit {

  breadcrumbPageName: string;
  pageName = "DashBoard";
  FinancialYear: string;
  FinancialDate: string;
  LoginUserName: string;
  DesignationId: number;
  DesignationName: string;
  EmployeeBranchName: string;
  pipe = new DatePipe('en-US');
  elem;
  expanded: boolean = true;
  imgURL:any = null;
  IsEnabled :boolean= false;
  RoleId: number;
  IsAutoLogout: string;
  IsAdminEnabled :boolean= false;

  constructor(private router: Router, private authService: AuthService,
    private _location: Location, public dialog: MatDialog,
    private commonmastersService: CommonmastersService,
    private autologoutService: AutologoutService,
    @Inject(DOCUMENT) private document: any,
    ) { }

  ngOnInit() {
    if (this.router.url != "/dashboard") {
      this.breadcrumbPageName = this.router.url.replace("/", "");
    }

    // checking User is Live or logout
    if(!localStorage.getItem("IsLoggedIn"))
      this.logout();

    this.GetFinancialYear();
    this.GetFinancialDate();
    this.GetLoginUserDetails();
    this.GetButtonDisabled();
    this.CheckAutoLogout();
    this.IsAdminEnabled = this.IsAdminPrevilege(JSON.parse(localStorage.getItem("EmployeeData"))["RoleId"]); // check the admin privilege
    // staff Image fetching
    const noImage = "../../../assets/staffimages/no_image_2.jpg";
    if(JSON.parse(localStorage.getItem("EmployeeData"))["PhotoFilePath"] != null){
      
      this.imgURL = environment.baseUrl + JSON.parse(localStorage.getItem("EmployeeData"))["PhotoFilePath"];
    }
    else{
      this.imgURL = noImage;
    }

    this.elem = document.documentElement; // Full screen 

  //   $(document).ready(function() {
  //     $(".main-sidebar").niceScroll({cursorwidth: '10px', autohidemode: false, zindex: 999 });
  // });

  // this.loadJsFile("src/assets/js/app.min.js"); 
  // this.loadJsFile("src/assets/js/scripts.js"); 

  }

  public loadJsFile(url) {  
    let node = document.createElement('script');  
    node.src = url;  
    node.type = 'text/javascript';  
    document.getElementsByTagName('head')[0].appendChild(node);  
  }  

  GetFinancialYear() {

    this.commonmastersService.GetFinancialYearList().subscribe(data => {
      localStorage.setItem("FinancialYear", data[0].Name);
      localStorage.setItem("FromDate", data[0].FromDate);
      localStorage.setItem("ToDate", data[0].ToDate);
      this.FinancialYear = '[ ' + localStorage.getItem("FinancialYear").toString() + ' ]';
    })
  }

  GetFinancialDate() {

    this.FinancialDate = "";
    this.FinancialDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
  }

  GetLoginUserDetails() {

    this.LoginUserName = JSON.parse(localStorage.getItem("EmployeeData"))["UserName"];
    this.DesignationId = JSON.parse(localStorage.getItem("EmployeeData"))["DesignationId"];
    this.DesignationName = JSON.parse(localStorage.getItem("EmployeeData"))["DesignationName"];
    this.EmployeeBranchName = JSON.parse(localStorage.getItem("EmployeeData"))["EmployeeBranchName"];
    this.RoleId = JSON.parse(localStorage.getItem("EmployeeData"))["RoleId"];
  }

  ngAfterViewInit() {

    Feather.replace();
  }

  GetButtonDisabled(){
    if(this.RoleId == 2 || this.RoleId == 3 || this.RoleId == 4){
      this.IsEnabled = false;
    }
  }

  // session logout 
  logout() {

    this.authService.logout();
    localStorage.setItem("IsLoggedIn", "false");
    localStorage.removeItem("EmployeeData");
    // localStorage.removeItem("ApplicationDate");
    localStorage.clear();
    this.router.navigate(['/login']);
    // console.log(localStorage.getItem("token"));
  }

  CheckAutoLogout(){

    this.IsAutoLogout = this.autologoutService.Val;
  }

  BackButton() {
    if (this.router.url === "/dashbord") { return; }
    this._location.back();
  }

  // Finacial year popup open
  ViewReports(rptName: any, dummyElement: any): void {

    let retVal: object;
    switch (rptName) {

      case 'Financialyear':
        retVal = FinancialyearpopupComponent;
        break;
    }

    this.OpenDialog(retVal);
  }

  IdValue: string;
  NameValue: string;

  OpenDialog(componentName: any): void {

    const dialogRef = this.dialog.open(componentName, {
      width: '300px', height: '400px', panelClass: 'modal-dialog', autoFocus: false,
      data: { Id: this.IdValue, Name: this.NameValue }
    });


    dialogRef.afterClosed().subscribe(result => {

      if (result != null) {

        let Branch_FinancialYear = result.split(',');

        localStorage.setItem("EmployeeBranchName", Branch_FinancialYear[0]);
        this.EmployeeBranchName = localStorage.getItem("EmployeeBranchName").toString();

        localStorage.setItem("FinancialYear", Branch_FinancialYear[1]);
        this.FinancialYear = '[ ' + localStorage.getItem("FinancialYear").toString() + ' ]';

        // this.router.navigate(['/'+ this.router.url]);
        this.router.navigate(['/dashboard']);
      }
    });

  }

  /*  Open full screen  */  
  openFullscreen() {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    if (document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

  // admin privilege check
  IsAdminPrevilege(value: number): value is Role { // typescript Type guard syntax.
    return Object.values(Role).includes(value);
  }
  //--------------------------------------------------------------------

  // ViewReports(rptName: any, dummyElement: any): void {

  //   let retVal: object;
  //   console.log(rptName);

  //   switch (rptName) {

  //     case 'loanapplication':
  //       retVal = RptloanapplicationpopupComponent;
  //       break;
  //     case 'loanapproval':
  //       retVal = RptloanapprovalpopupComponent;
  //       break;
  //     case 'loansanction':
  //       retVal = RptloansanctionpopupComponent;
  //       break;
  //     case 'loanreceipt':
  //       retVal = RptloanreceiptpopupComponent;
  //       break;
  //     case 'customers':
  //       retVal = RptcustomerpopupComponent;
  //       break;
  //     case 'collectionsheet':
  //       retVal = RptcollectionsheetpopupComponent;
  //       break;
  //     case 'demandsheet':
  //       retVal = RptdemandsheetpopupComponent;
  //       break;
  //     case 'passbook':
  //       retVal = RptpassbookpopupComponent;
  //       break;
  //     case 'emi':
  //       retVal = RptloanemipopupComponent;
  //       break;
  //     case 'ddfund':
  //       retVal = RptddfundpopuppComponent;
  //       break;
  //     case 'installment':
  //       retVal = RptinstallmentpopupComponent;
  //       break;
  //     case 'Financialyear':
  //       retVal = FinancialyearpopupComponent;
  //       break;
  //     case 'Ledger':
  //       retVal = RptledgerpopupComponent;
  //       break;
  //     case 'CashBook':
  //       retVal = RptcashbookpopupComponent;
  //       break;
  //     case 'DayBook':
  //       retVal = RptdaybookpopupComponent;
  //       break;
  //     case 'TrailBalance': 
  //       retVal = RpttrailbalancepopupComponent;
  //       break;

  //   }

  //   this.openDialog(retVal);
  // }

  // IdValue: string;
  // NameValue: string;
  // openDialog(componentName: any): void {


  //   const dialogRef = this.dialog.open(componentName, {
  //     width: '300px', height: '400px', panelClass: 'modal-dialog',
  //     autoFocus: false,
  //     // position: { top: '10px',right:'100px' },
  //     data: { Id: this.IdValue, Name: this.NameValue }

  //   });


  //   dialogRef.afterClosed().subscribe(result => {

  //     if (result != null) {
  //       let Branch_FinancialYear = result.split(',');

  //       localStorage.setItem("EmployeeBranchName", Branch_FinancialYear[0]);
  //       this.EmployeeBranchName = localStorage.getItem("EmployeeBranchName").toString();

  //       localStorage.setItem("FinancialYear", Branch_FinancialYear[1]);
  //       this.FinancialYear = '[ ' + localStorage.getItem("FinancialYear").toString() + ' ]';

  //       // this.router.navigate(['/'+ this.router.url]);
  //       this.router.navigate(['/dashboard']);
  //     }
  //   });
  // }

}
